import { http } from '@/lib/api-client'
import type {
  EmailMessageListResponse,
  ListEmailsParams,
  SendEmailInput,
} from './email.types'

// One email per call. Bulk sends loop over this once per recipient — there is no
// batched endpoint on purpose (per-recipient progress + isolation of failures).
export const emailApi = {
  send: (data: SendEmailInput): Promise<void> =>
    http.post('/emails', data).then(() => undefined),

  listMessages: (params?: ListEmailsParams): Promise<EmailMessageListResponse> =>
    http.get<EmailMessageListResponse>('/emails', { params }),
}
